import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../clients/client';
import { State } from '../redux/redux.state';
import { Status } from '../redux/redux.status';

type ShopDomainResponse = {
  domain: string;
};

type ShopDomainState = State<ShopDomainResponse> & {
  defaultDomain: { domain: string };
  updateStatus: Status;
};

const initialState: ShopDomainState = {
  data: { domain: '' },
  defaultDomain: { domain: '' },
  status: 'idle',
  updateStatus: 'idle',
};

export const getDomains = createAsyncThunk<{ domain: string }, string>(
  'shop/domains',
  async (shop_id: string, { rejectWithValue }) => {
    try {
      const { data } = await client.get(`/shop-domains/${shop_id}`);
      return data;
    } catch (error: any) {
      const { status, data } = error.response;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

export const updateDomains = createAsyncThunk<
  void,
  { shop_id: string; domain: string }
>(
  'shop/updateDomains',
  async (request: { shop_id: string; domain: string }, { rejectWithValue }) => {
    try {
      const { data } = await client.post(
        `shop-domains/update/${request.shop_id}`,
        {
          domain: request.domain,
        }
      );
      return data;
    } catch (error: any) {
      const { status, data } = error;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

const domainSlice = createSlice({
  name: 'shop-domains',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDomains.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getDomains.fulfilled, (state, { payload }) => {
        state.status = 'successful';
        state.data = payload;
        state.defaultDomain = payload;
      })
      .addCase(getDomains.rejected, (state, { payload }) => {
        state.status = 'error';
        state.errors = payload;
      })
      .addCase(updateDomains.pending, (state) => {
        state.updateStatus = 'loading';
      })
      .addCase(updateDomains.fulfilled, (state, { payload }) => {
        state.updateStatus = 'successful';
      })
      .addCase(updateDomains.rejected, (state, { payload }) => {
        state.updateStatus = 'error';
        state.errors = payload;
      });
  },
});

export default domainSlice.reducer;
